import '.ab{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.jw{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.ai{align-items:flex-start;}.ssr-plugin'
import '.eq{padding:2rem;}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.bx{position:absolute;}.ssr-plugin'
import '.fk{top:50%;}.ssr-plugin'
import '.fo{right:1rem;}.ssr-plugin'
import '.fl{transform:translateY(-50%);}.ssr-plugin'
import '.li{width:120px;}.ssr-plugin'
import '.lj{height:120px;}.ssr-plugin'
import '.lk{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.ll{max-width:calc(100% - 140px);}.ssr-plugin'
import '.lm{font-size:4rem;}.ssr-plugin'
import '.ck{font-weight:700;}.ssr-plugin'
import '.l0{line-height:100%;}.ssr-plugin'
import '.if{margin:0px;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.a6{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ab n jw a b ax ai eq do b5"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bx fk fo fl li lj lk a t ax"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ab e1 a b ai u ll"
      >
        <div className="lm ck l0 if a5 a6"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
